<div class="flex flex-row items-center justify-start gap-1.5">
	@if (showBack) {
	<button
		(click)="goBack.emit()"
		class="items-center justify-center"
		fxlayout="column"
		mat-icon-button
	>
		<mat-icon>arrow_back</mat-icon>
	</button>
	} @if (showSave) {
	<button
		(click)="saveDashboard.emit()"
		[matTooltip]="'reports.saveDashboard' | translate"
		class="items-center justify-center"
		fxlayout="column"
		mat-icon-button
	>
		<mat-icon>save</mat-icon>
	</button>
	} @if (timeLoading$ | async) {
	<div
		class="flex flex-col items-center justify-center"
		style="width: 40px; height: 40px"
	>
		<mat-progress-spinner
			[diameter]="20"
			[mode]="'indeterminate'"
			[strokeWidth]="2"
			color="primary"
		></mat-progress-spinner>
	</div>
	} @if (showRounding) {
	<button
		(click)="openRounding.emit()"
		[class.mat-accent]="(roundingData$ | async)?.enabled"
		[matTooltip]="'Rounding' | translate"
		class="items-center justify-center"
		fxlayout="column"
		mat-icon-button
	>
		<mat-icon>history</mat-icon>
	</button>
	} @if (showExport) {
	<button
		(click)="openExport.emit()"
		[disabled]="exportDisabled$ | async"
		[matTooltip]="'reports.export' | translate"
		class="items-center justify-center"
		fxlayout="column"
		mat-icon-button
	>
		<mat-icon>file_download</mat-icon>
	</button>
	}
</div>
